import { ConstantsService } from './../../services/constants-service';
import { ObservableRequestService } from './../../services/observable-request.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Rx';

import { Task } from 'app/shared/models/task.model'

/**
 * Service for displaying a navigation bar.
 */
@Injectable()
export class NavigationBarService {
    private selectedTask: Subject<Task>;

    constructor( private requestService: ObservableRequestService) {
        this.selectedTask = new Subject<Task>();
    }

    setSelectedTask(task: Task): void {
        this.selectedTask.next(task);
    }

    onSelectedTaskChanged(): Observable<any> {
        return this.selectedTask.asObservable();
    }

    fetchMyClients(): Observable<any> {
        return this.requestService.getRequest(
            ConstantsService.MY_CLIENTS_LIST);
    }

    deleteTransactionOfClient(clientId){
        return this.requestService.deleteRequest(
            `${ConstantsService.TRANSACTION}/${clientId}`, '', this.requestService.getJSONContentType());
    }

    validDateData(): Observable<any> {
        return this.requestService.getRequest(
            ConstantsService.VALIDATE_DATA_FOR_REPORT);
    }
}



// WEBPACK FOOTER //
// ./src/app/header/navigationbar/navigation-bar.service.ts